export default {
    agentEmpathyScore: {
        iconClassName: "icon-face-empathy",
    },
    unhelpfulBehaviorScore: {
        iconClassName: "icon-face-neutral",
    },
    neutralEmpathyScore: {
        iconClassName: "fa fa-minus-circle",
        iconName: "fa/subtract-circle-solid",
    },
};
